import { render, staticRenderFns } from "./DetailedDay.vue?vue&type=template&id=d65b29aa&scoped=true&"
import script from "./DetailedDay.vue?vue&type=script&lang=js&"
export * from "./DetailedDay.vue?vue&type=script&lang=js&"
import style0 from "./DetailedDay.vue?vue&type=style&index=0&id=d65b29aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65b29aa",
  null
  
)

export default component.exports